<template>
    <div class="upload-detail">
        <div class="upload-detail-left">
            <el-button
                v-if="(typeId == '1' && (!catIds || catIds.length === 0)) || !typeId"
                :disabled="loading"
                size="medium"
                type="text"
                @click="handleClick"
                ><i class="el-icon-upload"></i> 直接上传
            </el-button>
            <!-- <el-upload class="new-remib-upload-invoices"  -->
            <el-upload v-else class="new-remib-upload-invoices"
                action="" :limit="150"
                :show-file-list="false"
                :file-list="uploadFileList"
                :http-request="handleUpload"
                :on-progress="setLoadingTrue"
                :on-error="setLoadingFalse">
                <el-button
                    :disabled="loading"
                    size="medium"
                    type="text"
                    ><i class="el-icon-upload"></i> 直接上传
                </el-button>
            </el-upload>
            <el-button
                :disabled="loading"
                size="medium"
                type="text"
                @click="downloadTemplateByExt1"
                >点击下载模板
            </el-button>
        </div>
        <el-button
            v-if="typeId == '3'"
            :disabled="loading"
            size="medium"
            type="text"
            @click="$emit('addDetail')"
            ><i class="el-icon-plus"></i> 添加调整明细
        </el-button>
    </div>
</template>

<script>
/**
 * 调整明细 Excel 导入
 * V3.6.2：导入结果通过 normalizeImportShareType 补全 shareTypeNo/shareType 后回传父组件
 */
import { defineComponent, ref, toRef, reactive, watch, getCurrentInstance } from 'vue'

import {
    importBudgetExcel, // 预算调整
    downloadTemplate,
    importGrantExcel, // 弹性调整
} from '../request'
import { awaitWrapper, exportExecl } from "@/common/utils/assist.js"; //
import {
    getShareTypeLabel,
    defaultShareTypeNo,
} from "@/modules/yearBudget/constants/shareType.js"

export default defineComponent({
    props: {
        typeId: {
            type: [String, Number],
            required: true
        },
        year: {
            type: [String, Number],
            required: true
        },
        catIds: {
            type: Array,
            required: true
        },
        deptCodeList: {
            type: Array,
            required: true
        }
    },
    setup(props, context) {
        const { proxy } = getCurrentInstance()

        const exportExeclNameObj = {
            '1': '相同预算大类调整模板',
            '2': '相同一级部门调整模板',
            '3': '弹性授予调整模板',
            '4': '预算期间内后期预算调前期模板',
            '5': '预算外调整模板',
        }
        const { emit } = context
        const typeId = toRef(props, 'typeId')
        const loading = ref(false)
        const uploadParams = reactive({
            id: typeId.value,
        })
        const uploadFileList = ref([])

        watch(() => props.typeId, (newTypeId) => {
            uploadParams.id = newTypeId
        })
        
        const setLoadingTrue = () => {
            loading.value = true
            emit('setLoadingTrue')
        }
        const setLoadingFalse = () => {
            loading.value = false
            emit('setLoadingFalse')
        }
        // 根据
        const downloadTemplateByExt1 = async () => {
            if (!props.typeId) {
                proxy.$message.warning('请先选择预算调整类型')
                return false
            }
            const [, res] = await awaitWrapper(downloadTemplate({
                id: uploadParams.id == 5? 4: uploadParams.id,
            }))
            if (res) {
                exportExecl(res, exportExeclNameObj[uploadParams.id])
            }
        }
        // V3.6.2：导入成功后统一补全 shareTypeNo/shareType，与手动录入、提交逻辑一致
        const normalizeImportShareType = (item) => {
            const shareTypeNo = item.shareTypeNo || defaultShareTypeNo
            return Object.assign({}, item, {
                shareTypeNo: shareTypeNo,
                shareType: item.shareType || getShareTypeLabel(shareTypeNo),
            })
        }
        const handleUpload = async (upload) => {
            if (props.typeId == '1' && (!props.catIds || props.catIds.length === 0)) {
                toast('请先选择预算大类')
                return false
            }
            // if (props.typeId == '2' && (!props.deptCodeList || props.deptCodeList.length === 0)) {
            //     toast('请先选择一级部门')
            //     return false
            // }
            let formParams = new FormData();
            formParams.append("file", upload.file); // 文件
            if (props.typeId == '1') {
                formParams.append("catIds", props.catIds);
            } else if (props.typeId == '5' || props.typeId == '2') {
                formParams.append("catIds", []);
            }
            formParams.append("year", props.year); // 预算年度
            let res
            loading.value = true
            if (props.typeId == '3') {
                [, res] = await awaitWrapper(importGrantExcel(formParams))
            } else {
                [, res] = await awaitWrapper(importBudgetExcel(formParams))
            }
            try {
                const uint8_msg = new Uint8Array(res)
                // 分批处理，避免调用栈溢出
                const chunkSize = 8192
                let encodedString = ''
                for (let i = 0; i < uint8_msg.length; i += chunkSize) {
                    const chunk = uint8_msg.slice(i, i + chunkSize)
                    encodedString += String.fromCharCode.apply(null, chunk)
                }
                let decodedString = decodeURIComponent(escape(encodedString))
                const jsonData = JSON.parse(decodedString)
                if (String(jsonData.code) === '0' && jsonData.data && Array.isArray(jsonData.data.successList)) {
                    proxy.$message.success('导入成功')
                    const successList = jsonData.data.successList.map(normalizeImportShareType)
                    if (props.typeId == '3') {
                        proxy.$emit('setDetailListByExtType3', successList)
                    } else if (props.typeId == '1') {
                        proxy.$emit('setDetailListByExtType1', successList)
                    } else if (props.typeId == '2') {
                        proxy.$emit('setDetailListByExtType2', successList)
                    } else if (props.typeId == '5') { // 要根据返回的一级部门设置一级部门
                        proxy.$emit('setDetailListByExtType5', successList)
                    }
                } else {
                    // toast(jsonData.msg)
                }
                loading.value = false
            } catch (error) {
                console.log('error', error)
                proxy.$message.warning('导入文件存在错误，请在浏览器下载列表中打开《导入错误列表》')
                loading.value = false
                exportExecl(res, '导入错误列表')
            }
        }
        const handleClick = (e) => {
            if (props.typeId == '1' && (!props.catIds || props.catIds.length === 0)) {
                e.preventDefault()
                proxy.$message.warning('请先选择预算大类')
                return false
            } else if (!props.typeId) {
                proxy.$message.warning('请先选择预算调整类型')
                return false
            }
            // if (props.typeId == '2' && (!props.deptCodeList || props.deptCodeList.length === 0)) {
            //     e.preventDefault()
            //     proxy.$message.warning('请先选择一级部门')
            //     return false
            // }
        }

        return {
            uploadFileList,
            loading,
            handleUpload,
            setLoadingFalse,
            setLoadingTrue,
            uploadParams,
            downloadTemplateByExt1,
            handleClick,
        }
    },
})
</script>

<style lang="scss" scoped>
.upload-detail {
    display: flex;
    align-items: center;
    margin-top: 10px;
    justify-content: space-between;
}
.upload-detail-left {
    display: flex;
    align-items: center;
}
</style>
